import React from "react";
import { IRCAActionPlansFilterSelected } from "pages/Corporate/RCA/RCAActionPlans/components/RCAActionPlansFilters/RCAActionPlansFiltersInterfaces";

export interface IRCAActionPlanFiltersContext {
    filters: IRCAActionPlansFilterSelected;
    handleFiltersChange: (value: IRCAActionPlansFilterSelected) => void;
    handleRemoveDefaultFilters: () => Promise<void>;
    handleSetFiltersDefault: (filters: IRCAActionPlansFilterSelected) => Promise<void>;
    userFiltersDefault: IRCAActionPlansFilterSelected | null;
    loadingDefaultOperations: boolean;
    isFiltersDefault: boolean;
}

export const initialRCAActionPlanFilters: IRCAActionPlansFilterSelected = {
    showCompleted: false,
    ownerIds: [],
    statusesIds: [],
    meetingTypeIds: [],
    totalMeetingTypes: 0,
    searchText: "",
};

export const RCAActionPlanFiltersContext = React.createContext<IRCAActionPlanFiltersContext>({
    filters: initialRCAActionPlanFilters,
    handleFiltersChange: () => {},
    handleRemoveDefaultFilters: async () => {},
    handleSetFiltersDefault: async () => {},
    userFiltersDefault: null,
    loadingDefaultOperations: false,
    isFiltersDefault: false,
});
